  import NiIcon from "../icon"


	export default{
    components:{
      NiIcon,
    },
		props:{
      visible:{
				type:Boolean,
				default:false,
			},

      beforeClose: Function,

      title:{
			  type:String,
				default:""
      },

      drawer_height: {
        type: [String, Number],
				default:""
      },

      drawer_width: {
        type: [String, Number],
        default:""
      },

      drawer_style: {
        type: Object,
				default: function () {
          return {}
        }
      },

      drawer_position: {
        type:String,
        default:"bottom",   //  bottom / right
      }

		},
		data(){
			return {
				box_show: false,
        body_show: false,

        header_tool_icon: {
          padding: '0px 2px',
          width: '1.1em',
          height: '1.1em',
        },

        height_of_position: {
				  top: "calc(70% - 16px)",
				  bottom: "calc(70% - 16px)",
				  left: "calc(100% - 16px)",
				  right: "calc(100% - 16px)",
        },
        width_of_position: {
				  top: "calc(100% - 20px)",
				  bottom: "calc(100% - 20px)",
				  left: "calc(45% - 20px)",
				  right: "calc(45% - 20px)",
        },
			}
		},

		watch:{
			visible(val){
        this.handle_show(val);
      },
		},

    mounted(){
      this.handle_show(this.visible);
    },

    computed: {
      set_drawer_style(){
        let height = this.height_of_position[this.drawer_position];
        let width = this.width_of_position[this.drawer_position];
        let style = {};
        if (this.drawer_style && JSON.stringify(this.drawer_style) !== "{}") style = Object.assign({}, this.drawer_style);
        if(this.drawer_height){
          height = String(this.drawer_height);
          height = height.indexOf("%") > -1 || height.indexOf("px") > -1 ? height : height + "px";
          height = `calc(${height} - 16px)`;
        }
        if(this.drawer_width){
          width = String(this.drawer_width);
          width = width.indexOf("%") > -1 || width.indexOf("px") > -1 ? width : width + "px";
          width = `calc(${width} - 20px)`;
        }
        style.height = style.height || height;
        style.width = style.width || width;
        return style;
      },

      position_set(){
        if (this.drawer_position === "bottom") return "is-vertical is-bottom"
        if (this.drawer_position === "right") return "is-horizontal is-right"
      },
    },

    methods:{

      handle_show(show){
          if(show){
            this.box_show = true;
            this.body_show = true;
          } else {
            this.body_show = false;
            setTimeout(() =>{
              this.box_show = false;
            }, 100)
          }
      },

      // 点击关闭按钮
      handle_close(){
        if (typeof this.beforeClose === 'function') {
          this.beforeClose(this.close);
        } else {
          this.close();
        }
      },

      // 关闭
      close(){
        this.$emit('update:visible', false);
      },
    },
	}



// WEBPACK FOOTER //
// ./src/ni-ui/drawer/drawer.js